'use client';
import React from 'react';
import subMonths from 'date-fns/subMonths';

import Layout from '../lib/components/Layout';
import CalendarService from '../lib/services/CalendarService';
import ColumnsDefinition from './ColumnsDef';
import { formatRequestDate } from '../lib/utils';

import { ICalendarProps, IDateRange } from '../lib/interfaces';
import { fetchMA } from './Services';
import { MergersAndAcquisitions } from '@benzinga/calendar-manager';

export const MACalendarColumnsDef = ColumnsDefinition;
export const fetchMAData = fetchMA;

export const MACalendar: React.FC<ICalendarProps> = ({
  calendar,
  calendarData,
  hasStockTableStyling,
  height,
  initialData,
  initialDateRange,
  leftSlot,
  onReady,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [tableData, setTableData] = React.useState<MergersAndAcquisitions[]>(initialData || []);
  let dateRange: IDateRange;

  if (initialDateRange) {
    dateRange = initialDateRange;
  } else {
    dateRange = {
      date_from: formatRequestDate(subMonths(new Date(), 2)),
      date_to: formatRequestDate(new Date()),
    };
  }

  React.useEffect(() => {
    if (calendarData?.serverSide) {
      setTableData(initialData);
    }
  }, [initialData, calendarData]);

  function onTableReady() {
    if (initialData) {
      setTableData(initialData);
    } else {
      const params = {
        'parameters[date_from]': dateRange.date_from,
        'parameters[date_to]': dateRange.date_to,
      };
      fetchData(params);
    }

    if (onReady) {
      setTimeout(() => onReady());
    }
  }

  function fetchData(filterParams: any) {
    const query = {
      ...filterParams,
      pagesize: 1000,
    };

    setLoading(true);

    const Calendar = new CalendarService();
    Calendar.getMA(query)
      .then(({ data }: any) => {
        if (data && data.ma) {
          setTableData(data.ma);
        }
      })
      .finally(() => setLoading(false));
  }

  return (
    <Layout
      calendar={calendar}
      calendarData={calendarData}
      columnDefs={ColumnsDefinition}
      enableSearch
      hasStockTableStyling={hasStockTableStyling}
      height={height}
      initialDateRange={dateRange}
      leftSlot={leftSlot}
      onFilterChanged={fetchData}
      onTableReady={onTableReady}
      tableData={tableData}
      tableLoading={loading}
    />
  );
};
